/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { all } from 'redux-saga/effects';

import { appSaga } from './appSaga';
import { authMainSaga } from './auth/sagas';
import { notificationsMainSaga } from './notifications/sagas';
import { organizationMainSaga } from './organization/sagas';
import { planMainSaga } from './plan/sagas';

export function* rootSaga() {
  yield all([appSaga(), organizationMainSaga(), planMainSaga(), authMainSaga(), notificationsMainSaga()]);
}
